import React from 'react'
import { Container } from './styled'

interface Props {
  type?: 'success' | 'danger' | 'warning' | 'info'
  children: React.ReactElement | string
}

export const Alert = ({ type, children }: Props) => {
  return (
    <Container
      type={type ?? 'info'}
    >
      {children}
    </Container>
  )
}

Alert.styled = Container
